import React, { PureComponent } from 'react';

class LightningAnimation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { phase: 0 };
    }

    componentDidMount() {
        this.timer1 = setTimeout(() => this.setState({ phase: 1 }), 200);
        this.timer2 = setTimeout(() => this.setState({ phase: 2 }), 400);
        this.timer3 = setTimeout(() => this.setState({ phase: 3 }), 800);
    }

    componentWillUnmount() {
        clearTimeout(this.timer1);
        clearTimeout(this.timer2);
        clearTimeout(this.timer3);
    }

    render() {
        const { phase } = this.state;
        return (
            <div style={styles.container}>
                <style>{keyframes}</style>
                {phase < 3 && (
                    <div style={{
                        ...styles.flash,
                        opacity: phase === 1 ? 0.8 : phase === 2 ? 0.4 : 0,
                    }} />
                )}
                <svg style={styles.bolt} viewBox="0 0 100 200" xmlns="http://www.w3.org/2000/svg">
                    <polygon
                        points="55,0 30,90 50,90 25,200 80,75 55,75 75,0"
                        fill="#FFD700"
                        filter="url(#glow)"
                        style={{ animation: 'bolt-appear 0.3s ease-out forwards' }}
                    />
                    <defs>
                        <filter id="glow">
                            <feGaussianBlur stdDeviation="4" result="blur" />
                            <feMerge>
                                <feMergeNode in="blur" />
                                <feMergeNode in="SourceGraphic" />
                            </feMerge>
                        </filter>
                    </defs>
                </svg>
            </div>
        );
    }
}

const keyframes = `
@keyframes bolt-appear {
    0% { opacity: 0; transform: scale(0.5); }
    50% { opacity: 1; transform: scale(1.2); }
    100% { opacity: 1; transform: scale(1); }
}
`;

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    flash: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff',
        transition: 'opacity 0.15s ease-out',
    },
    bolt: {
        width: 120,
        height: 240,
        filter: 'drop-shadow(0 0 20px rgba(255, 215, 0, 0.8))',
    },
};

export default LightningAnimation;
